import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.some.js";
import Role from "./Role";
import Permission from "./Permission";
import Country from "./Country";
import Pixel from "./Pixel";
import Product from "./Product";
import SalePage from "./SalePage";
import Order from "./Order";
import Client from "./Client";
import Warehouse from "./Warehouse";
import Image from "../library/Image";
import moment from "moment";
import BankDetails from "./BankDetails";
import Payoneer from "./Payoneer";
import { refreshStringifiedModel } from "../../../assets/js/mcn-helpers";
import Model from "./Model";
import UserSettings from "./user/UserSettings";
import UserIdVerification from "./UserIdVerification";
import SubscriptionPlan from "./SubscriptionPlan";
export class User extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "id", {
      fieldName: 'user_id',
      content: null
    });
    _defineProperty(this, "Id", {
      fieldName: 'user_id',
      content: null
    });
    _defineProperty(this, "UserId", {
      fieldName: 'user_id',
      content: null
    });
    _defineProperty(this, "AdvertiserWarehouseID", {
      fieldName: 'warehouse_id',
      content: null
    });
    _defineProperty(this, "AdvertiserWarehouse", {
      fieldName: 'advertiser_warehouse',
      model: Warehouse,
      content: null
    });
    _defineProperty(this, "CallAgentWarehouse", {
      fieldName: 'call_agent_warehouse',
      model: Warehouse,
      content: null
    });
    // this play a different role depending of the users role
    _defineProperty(this, "UserWarehouseID", {
      fieldName: 'warehouse_id',
      content: null
    });
    _defineProperty(this, "UserWarehouse", {
      fieldName: 'user_warehouse',
      model: Warehouse,
      content: null
    });
    _defineProperty(this, "warehouse", {
      fieldName: 'warehouse',
      model: Warehouse,
      content: null
    });
    _defineProperty(this, "UserManager", {
      fieldName: 'user_manager',
      model: User,
      content: null
    });
    _defineProperty(this, "UserClient", {
      fieldName: 'user_client',
      model: Client,
      content: null
    });
    _defineProperty(this, "UserName", {
      fieldName: 'user_name',
      content: null
    });
    _defineProperty(this, "UserFullName", {
      fieldName: 'user_full_name',
      content: null
    });
    _defineProperty(this, "UserEmail", {
      fieldName: 'user_email',
      content: null
    });
    _defineProperty(this, "UserRole", {
      fieldName: 'user_role',
      model: Role,
      content: null
    });
    _defineProperty(this, "role", {
      fieldName: 'role',
      model: Role,
      content: null
    });
    _defineProperty(this, "UserCountry", {
      fieldName: 'user_country',
      model: Country,
      content: null
    });
    _defineProperty(this, "UserCountryID", {
      fieldName: 'country_id',
      content: null
    });
    _defineProperty(this, "UserCompany", {
      fieldName: 'user_company',
      content: null
    });
    _defineProperty(this, "UserPhone", {
      fieldName: 'user_phone',
      content: null
    });
    _defineProperty(this, "AdvertiserType", {
      fieldName: 'advertiser_type',
      content: null
    });
    _defineProperty(this, "UserSkype", {
      fieldName: 'user_skype_id',
      content: null
    });
    _defineProperty(this, "SellerStatus", {
      fieldName: 'seller_status',
      content: null
    });
    _defineProperty(this, "UserStatus", {
      fieldName: 'user_status',
      fieldTitle: 'User status',
      content: null
    });
    _defineProperty(this, "UserImage", {
      fieldName: 'user_image',
      model: Image,
      content: null
    });
    _defineProperty(this, "image", {
      fieldName: 'image',
      model: Image,
      content: null
    });
    _defineProperty(this, "avatar", {
      fieldName: 'avatar',
      model: Image,
      content: null
    });
    _defineProperty(this, "UserSignUpDate", {
      fieldName: 'created_at',
      content: null
    });
    _defineProperty(this, "UserEmailVerified", {
      fieldName: 'email_verified_at',
      content: null
    });
    _defineProperty(this, "UserConfirmedSales", {
      fieldName: 'user_confirmed_sales',
      content: null
    });
    _defineProperty(this, "CallAgentType", {
      fieldName: 'call_agent_type',
      content: null
    });
    _defineProperty(this, "SellerTotalConfirmedEarnings", {
      fieldName: 'user_total_confirmed_earnings',
      content: null
    });
    _defineProperty(this, "UserPixels", {
      fieldName: 'user_pixels',
      model: Pixel,
      content: {}
    });
    _defineProperty(this, "UserPermissions", {
      fieldName: 'permissions',
      model: Permission,
      content: []
    });
    _defineProperty(this, "CallAgentProducts", {
      fieldName: 'call_agent_products',
      model: Product,
      content: []
    });
    _defineProperty(this, "UserSellers", {
      fieldName: 'manager_users',
      model: User,
      content: []
    });
    _defineProperty(this, "UserSalePages", {
      fieldName: 'user_sale_pages',
      model: SalePage,
      content: []
    });
    _defineProperty(this, "CallAgentOrders", {
      fieldName: 'call_agent_orders',
      model: Order,
      content: []
    });
    _defineProperty(this, "UserLastMonthConfirmedSales", {
      fieldName: 'last_30_days_earnings',
      content: 0
    });
    _defineProperty(this, "UserNewsLetter", {
      fieldName: 'user_news_letter_subscribed',
      content: false
    });
    _defineProperty(this, "UserInstagramLinkVerification", {
      fieldName: 'user_instagram_link_verification',
      content: false
    });
    _defineProperty(this, "UserInstagramLink", {
      fieldName: 'user_instagram_link',
      content: null
    });
    _defineProperty(this, "UserYoutubeLink", {
      fieldName: 'user_youtube_link',
      content: null
    });
    _defineProperty(this, "UserConversionTrackingUrl", {
      fieldName: 'seller_conversion_tracking_url',
      content: null
    });
    _defineProperty(this, "UserSpeakingLanguage", {
      fieldName: 'user_speaking_language',
      content: null,
      options: [{
        text: 'Arabic',
        value: 'ar'
      }, {
        text: 'English',
        value: 'en'
      }, {
        text: 'French',
        value: 'fr'
      }, {
        text: 'Italian',
        value: 'it'
      }, {
        text: 'Spanish',
        value: 'es'
      }]
    });
    _defineProperty(this, "UserActivityPoints", {
      fieldName: 'user_activity_points',
      content: 0
    });
    _defineProperty(this, "UserLoggedAt", {
      fieldName: 'logged_at',
      content: null
    });
    _defineProperty(this, "UserExperienceDescription", {
      fieldName: 'experience_description',
      content: null
    });
    _defineProperty(this, "UserPostBackUrl", {
      fieldName: 'seller_conversion_tracking_url',
      content: null
    });
    _defineProperty(this, "UserBankDetails", {
      fieldName: 'user_bank_details',
      model: BankDetails,
      content: null
    });
    _defineProperty(this, "UserBankPayoneer", {
      fieldName: 'user_payoneer',
      model: Payoneer,
      content: null
    });
    _defineProperty(this, "UserFavoritePaymentMethod", {
      fieldName: 'payment_method',
      content: User.BANK_TRANSFER_PAYMENT_METHOD
    });
    _defineProperty(this, "referralId", {
      fieldName: 'referral_id',
      content: null
    });
    _defineProperty(this, "referrer", {
      fieldName: 'referrer',
      model: User,
      content: null
    });
    _defineProperty(this, "lastThirtyDaysDeliveredSales", {
      fieldName: 'last_thirty_days_delivered_sales',
      content: 0
    });
    _defineProperty(this, "lastThirtyDaysDeliveredEarnings", {
      fieldName: 'last_thirty_days_delivered_earnings',
      content: 0
    });
    _defineProperty(this, "lastThirtyDaysDeliveredOrders", {
      fieldName: 'last_thirty_days_delivered_orders',
      content: 0
    });
    _defineProperty(this, "settings", {
      fieldName: 'settings',
      model: UserSettings,
      content: new UserSettings()
    });
    _defineProperty(this, "paymentInfo", {
      fieldName: 'has_payment_info',
      content: false
    });
    _defineProperty(this, "identityVerification", {
      fieldName: 'identity_verification',
      model: UserIdVerification,
      content: null
    });
    _defineProperty(this, "subscriptionPlan", {
      fieldName: 'subscription_plan',
      model: SubscriptionPlan,
      content: null
    });
    _defineProperty(this, "nextSubscriptionPlan", {
      fieldName: 'next_subscription_plan',
      model: SubscriptionPlan,
      content: null
    });
    _defineProperty(this, "jsonPermissions", {
      fieldName: 'json_permissions',
      content: []
    });
  }
  getJsonPermissions() {
    var _this$jsonPermissions;
    return (_this$jsonPermissions = this.jsonPermissions.content) !== null && _this$jsonPermissions !== void 0 ? _this$jsonPermissions : [];
  }
  getIdentityVerification() {
    return this.identityVerification.content;
  }
  getLast30DaysDeliveredOrders() {
    return this.lastThirtyDaysDeliveredOrders.content;
  }
  hasPaymentInfo() {
    return this.paymentInfo.content;
  }
  getId() {
    var _this$Id$content;
    return (_this$Id$content = this.Id.content) !== null && _this$Id$content !== void 0 ? _this$Id$content : this.id.content;
  }
  getName() {
    return this.UserName.content;
  }
  getWarehouseId() {
    return this.UserWarehouseID.content;
  }
  getUserWarehouse() {
    return this.UserWarehouse.content;
  }
  getWarehouse() {
    return this.warehouse.content;
  }
  getUserWarehouseId() {
    let userWarehouse = this.getUserWarehouse();
    return userWarehouse instanceof Warehouse ? userWarehouse.getId() : null;
  }
  getInfluencerClient() {
    return this.UserClient.content;
  }
  getCallAgentType() {
    return this.CallAgentType.content;
  }
  isMainCallAgent() {
    return this.getCallAgentType() === User.CALL_AGENT_MAIN_TYPE;
  }
  getLastThirtyDaysDeliveredSales() {
    return this.lastThirtyDaysDeliveredSales.content;
  }
  getPixels() {
    return this.UserPixels.content;
  }
  getPostBackUrl() {
    return this.UserPostBackUrl.content;
  }
  getReferrer() {
    return this.referrer.content;
  }
  getAdvertiserType() {
    return this.AdvertiserType.content;
  }
  getReferrerName() {
    let referrer = this.getReferrer();
    return referrer instanceof User ? referrer.getUserName() : null;
  }
  getSignupDate() {
    return this.UserSignUpDate.content;
  }
  getSkype() {
    return this.UserSkype.content;
  }
  isSubscribedToNewsletter() {
    return this.UserNewsLetter.content;
  }
  getManager() {
    return this.UserManager.content;
  }
  getManagerName() {
    let manager = this.getManager();
    return manager instanceof User ? manager.getUserName() : null;
  }
  getYoutubeChannelLink() {
    return this.UserYoutubeLink.content;
  }
  getInstagramProfileLink() {
    return this.UserInstagramLink.content;
  }
  getSellerStatus() {
    return this.SellerStatus.content;
  }
  getExperienceDescription() {
    return this.UserExperienceDescription.content;
  }
  getCompanyName() {
    return this.UserCompany.content;
  }
  getReferralId() {
    return this.referralId.content;
  }
  static getPaymentMethods() {
    return [User.BANK_TRANSFER_PAYMENT_METHOD, User.PAYONEER_PAYMENT_METHOD];
  }
  hasPaymentMethod() {
    return User.getPaymentMethods().includes(this.UserFavoritePaymentMethod.content);
  }
  getPaymentMethod() {
    var _this$UserFavoritePay;
    return (_this$UserFavoritePay = this.UserFavoritePaymentMethod) === null || _this$UserFavoritePay === void 0 ? void 0 : _this$UserFavoritePay.content;
  }
  getLoggedAt() {
    return this.UserLoggedAt.content;
  }
  getActivityPoints() {
    return this.UserActivityPoints.content;
  }
  getCreatedAt() {
    return this.UserSignUpDate.content;
  }
  getLoggedAtStatus() {
    let from = this.getLoggedAt();
    let to = new Date();
    let hours = moment.duration({
      from: from,
      to: to
    }).asHours();
    return from || from === 0 ? hours <= 24 ? 'success' : hours <= 72 ? 'warning' : 'danger' : 'danger';
  }
  getLoggedInFromNow(lang = 'en') {
    let date = this.getLoggedAt();
    return moment(date).isValid() ? moment(date).locale(lang).fromNow() : 'unknown';
  }
  isActive() {
    return this.UserStatus.content === User.ACTIVE_STATUS;
  }
  getUserName() {
    var _this$UserName;
    return (_this$UserName = this.UserName) === null || _this$UserName === void 0 ? void 0 : _this$UserName.content;
  }
  isInactive() {
    return this.UserStatus.content === User.INACTIVE_STATUS || !this.UserStatus.content;
  }
  getUserEmail() {
    var _this$UserEmail;
    return (_this$UserEmail = this.UserEmail) === null || _this$UserEmail === void 0 ? void 0 : _this$UserEmail.content;
  }
  getEmail() {
    var _this$UserEmail2;
    return (_this$UserEmail2 = this.UserEmail) === null || _this$UserEmail2 === void 0 ? void 0 : _this$UserEmail2.content;
  }
  getUserCountry() {
    var _this$UserCountry;
    return (_this$UserCountry = this.UserCountry) === null || _this$UserCountry === void 0 ? void 0 : _this$UserCountry.content;
  }
  getCountry() {
    return this.UserCountry.content;
  }
  getStatus() {
    return this.UserStatus.content;
  }
  getFullName() {
    return this.UserFullName.content;
  }
  getUserPhone() {
    var _this$UserPhone;
    return (_this$UserPhone = this.UserPhone) === null || _this$UserPhone === void 0 ? void 0 : _this$UserPhone.content;
  }
  isSeller() {
    let role = this.getRole();
    return role instanceof Role ? role.isAffiliate() : false;
  }
  isAffiliate() {
    let role = this.getRole();
    return role instanceof Role ? role.isAffiliate() : false;
  }
  getTutorials() {
    let role = this.getRole();
    return role instanceof Role ? role.getTutorials() : [];
  }
  isStandard() {
    var _this$SellerStatus;
    return ((_this$SellerStatus = this.SellerStatus) === null || _this$SellerStatus === void 0 ? void 0 : _this$SellerStatus.content) === 'standard';
  }
  getUserImage() {
    var _this$UserImage$conte;
    return (_this$UserImage$conte = this.UserImage.content) !== null && _this$UserImage$conte !== void 0 ? _this$UserImage$conte : this.image.content;
  }
  getImage() {
    var _ref, _this$UserImage$conte2;
    return (_ref = (_this$UserImage$conte2 = this.UserImage.content) !== null && _this$UserImage$conte2 !== void 0 ? _this$UserImage$conte2 : this.image.content) !== null && _ref !== void 0 ? _ref : this.avatar.content;
  }
  getPhoneNumber() {
    return this.UserPhone.content;
  }
  getUserImageUrl() {
    return this.getUserImage();
  }
  getImageUrl() {
    let image = this.getImage();
    return image instanceof Image ? image.getUrl() : null;
  }
  getUserRole() {
    var _this$UserRole$conten, _this$UserRole;
    return (_this$UserRole$conten = (_this$UserRole = this.UserRole) === null || _this$UserRole === void 0 ? void 0 : _this$UserRole.content) !== null && _this$UserRole$conten !== void 0 ? _this$UserRole$conten : this.role.content;
  }
  getRole() {
    var _this$UserRole$conten2;
    return (_this$UserRole$conten2 = this.UserRole.content) !== null && _this$UserRole$conten2 !== void 0 ? _this$UserRole$conten2 : this.role.content;
  }
  getUserRoleName() {
    var _this$getUserRole;
    return (_this$getUserRole = this.getUserRole()) === null || _this$getUserRole === void 0 || (_this$getUserRole = _this$getUserRole.RoleName) === null || _this$getUserRole === void 0 ? void 0 : _this$getUserRole.content;
  }
  getRoleName() {
    let role = this.getRole();
    return role instanceof Role ? role.getName() : null;
  }
  getResolvedUserImageUrl() {
    let imageUrl = this.getImageUrl();
    if (imageUrl) return imageUrl;
    switch (this.getUserRoleName()) {
      case Role.ADMIN_ROLE:
        return require('../../../assets/boss.svg');
      case Role.MANAGER_ROLE:
        return require('../../../assets/business-man.svg');
      case Role.WAREHOUSE_ROLE:
        return require('../../../assets/delivery-man.svg');
      case Role.CALL_AGENT_ROLE:
        return require('../../../assets/call-agent.svg');
      default:
        return require('../../../assets/img/account_avatar.png');
    }
  }
  static createNewInstanceFrom(oldInstance) {
    return refreshStringifiedModel(new User(), oldInstance);
  }
  getUserSelectObject(text = 'text', value = 'value') {
    var _this$UserName2, _this$UserId;
    return {
      [text]: (_this$UserName2 = this.UserName) === null || _this$UserName2 === void 0 ? void 0 : _this$UserName2.content,
      [value]: (_this$UserId = this.UserId) === null || _this$UserId === void 0 ? void 0 : _this$UserId.content
    };
  }
  getAdvertiserWarehouse() {
    return this.AdvertiserWarehouseID.content;
  }
  getPermissions() {
    var _this$UserPermissions;
    return (_this$UserPermissions = this.UserPermissions.content) !== null && _this$UserPermissions !== void 0 ? _this$UserPermissions : [];
  }
  isPermitted(permission) {
    if (!permission || permission === ['*']) return true;
    if (Array.isArray(permission)) {
      return this.isPermittedInEvery(permission);
    }
    return this.getJsonPermissions().some(jsonPermission => new RegExp(`^${permission}`).exec(jsonPermission));
  }
  isSomePermitted(permission) {
    if (Array.isArray(permission) && !permission.length) return true;
    return this.isPermittedInSome(permission);
  }
  isRolePermitted(role) {
    return Array.isArray(role) ? role.length < 1 || role.includes('*') || role.includes(this.getRoleName()) : !role || role === this.getRoleName();
  }
  isPermittedInEvery(permissions) {
    if (!Array.isArray(permissions)) {
      return this.isPermitted(permissions);
    }
    return permissions.every(permission => this.isPermitted(permission));
  }
  isPermittedInSome(permissions) {
    if (!Array.isArray(permissions)) {
      return this.isPermitted(permissions);
    }
    return permissions.some(permission => this.isPermitted(permission));
  }
  isEmailVerified() {
    return this.UserEmailVerified.content;
  }
  getSubscriptionPlan() {
    return this.subscriptionPlan.content;
  }
}
_defineProperty(User, "ACTIVE_STATUS", 'active');
_defineProperty(User, "INACTIVE_STATUS", 'inactive');
_defineProperty(User, "SUSPENDED_STATUS", 'suspended');
_defineProperty(User, "SOLO_ADVERTISER_TYPE", 'solo');
_defineProperty(User, "HYBRID_ADVERTISER_TYPE", 'hybrid');
_defineProperty(User, "INDEPENDENT_ADVERTISER_TYPE", 'independent');
_defineProperty(User, "STANDARD_SELLER_STATUS", 'standard');
_defineProperty(User, "EXCLUSIVE_SELLER_STATUS", 'exclusive');
_defineProperty(User, "PRIVATE_SELLER_STATUS", 'private');
_defineProperty(User, "TEST_SELLER_STATUS", 'test');
_defineProperty(User, "BANK_TRANSFER_PAYMENT_METHOD", 'bank-transfer');
_defineProperty(User, "PAYONEER_PAYMENT_METHOD", 'payoneer');
_defineProperty(User, "CALL_AGENT_MAIN_TYPE", 'main');
export default User;